import React from 'react'
import axios from 'axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import FormError from '~/Common-Objects/UI/Forms/FormError/FormError'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import LeftPanel from './loginAttractMode.jsx'
import RegisterComplete from './registerComplete'
import DbConn from '~/Classes/siteVars.js'
// import i18n from '~/i18n'
import { Translation } from 'react-i18next'
import queryString from 'query-string'
import * as user from '~/data/actions/userActions' //now we can use user actions here
import GoogleAnalytics from '~/Classes/googleAnalytics'
import TranspondTracking from '../../Classes/siteTrackingHelpers.jsx'
import LandingPageTemplate from './template.jsx'
import i18n from '~/i18n'
import postHogFunctions from '~/Classes/posthog.jsx'
import { isPasswordStrongEnough } from '~/utils/passwordPolicy'
//CONNECT TO STORE
@connect((store) => {
    return {
        user: store.user,
        siteMaster: store.siteMaster
    }
})
export default class RegisterForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            companyName: '',
            emailAddress: '',
            password: '',
            fullName: '',
            firstName: '',
            lastName: '',
            masterErrorMsg: '',
            confirmEmail: '',
            confirmPassword: '',
            confirmEmailError: '',
            confirmPasswordError: '',
            accountNameError: '',
            firstNameError: '',
            lastNameError: '',
            emailAddressError: '',
            complete: false,
            newsletterSignup: false,
            welcome: true,
            isMobile: false,
            affiliateId: '',
            psx_id: '',
            mpztid: '',
            approvedTerms: false,
            termsError: '',
            type: 'password'
        }
        this.inputChange = this.inputChange.bind(this)
        this.checkRegistration = this.checkRegistration.bind(this)
        this.redirectToPage = this.redirectToPage.bind(this)
        this.checkNewsletter = this.checkNewsletter.bind(this)
        this.updateDimensions = this.updateDimensions.bind(this)
        this.login = this.login.bind(this)
        this.checkInputs = this.checkInputs.bind(this)
    }

    componentDidMount() {
        const query = queryString.parse(location.search)
        const welcome = query.welcome
        const affiliateId = query.aff
        const mpztid = query.mpztid
        this.setState(
            {
                welcome: !welcome,
                affiliateId: affiliateId,
                mpztid: mpztid,
                ps_xid: query.ps_xid,
                gclid: query.gclid
            },
            this.updateDimensions
        )
        window.addEventListener('resize', this.updateDimensions)
    }

    updateDimensions() {
        this.setState({ isMobile: window.innerWidth < 1025 })
    }

    redirectToPage(pageURL) {
        this.props.history.push('/' + pageURL)
    }

    inputChange(event) {
        this.setState(
            {
                [event.currentTarget.name]: event.currentTarget.value
            },
            () => {
                if (this.state.hasCheckedForErrors) {
                    this.checkInputs()
                }
            }
        )
    }

    login() {
        this.props.dispatch(user.loginAndGetToken(this.state.emailAddress, this.state.password))
    }

    checkInputs() {
        if (!this.state.touched) return
        var obj = {
            confirmEmailError: '',
            confirmPasswordError: '',
            accountNameError: '',
            firstNameError: '',
            lastNameError: '',
            emailAddressError: '',
            masterErrorMsg: '',
            hasCheckedForErrors: true,
            termsError: ''
        }
        var hasErrors = false

        if (!this.state.companyName || this.state.companyName.length < 3) {
            hasErrors = true
            if (!this.state.companyName) {
                obj.accountNameError = i18n.t('login:register.blankOrg')
            } else {
                obj.accountNameError = i18n.t('login:register.invalidOrg')
            }
        } else {
            try {
                var regex =
                    /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/gi
                if (regex.test(this.state.companyName)) {
                    hasErrors = true
                    obj.accountNameError = i18n.t('login:register.orgHasLinks')
                }
            } catch (e) {}
        }

        if (!this.state.firstName || this.state.firstName.length < 3) {
            hasErrors = true
            if (!this.state.firstName) {
                obj.firstNameError = i18n.t('login:register.blankFirst')
            } else {
                obj.firstNameError = i18n.t('login:register.invalidFirst')
            }
        }

        if (!this.state.lastName || this.state.lastName.length < 3) {
            hasErrors = true
            if (!this.state.lastName) {
                obj.lastNameError = i18n.t('login:register.blankLast')
            } else {
                obj.lastNameError = i18n.t('login:register.invalidLast')
            }
        }

        if (!this.state.emailAddress || this.state.emailAddress.length < 3) {
            console.log('email bad')
            hasErrors = true
            if (!this.state.emailAddress) {
                obj.emailAddressError = i18n.t('login:register.blankEmail')
            } else {
                obj.emailAddressError = i18n.t('login:register.invalidEmail')
            }
        }

        if (!this.state.password) {
            hasErrors = true
            obj.masterErrorMsg = i18n.t('login:register.blankPassword', { siteName: this.props.siteMaster.siteName })
        } else if (!isPasswordStrongEnough(this.state.password)) {
            hasErrors = true
            obj.masterErrorMsg = i18n.t('login:reset.strong')
        }

        let requiresTerms = false
        if (
            (this.props.siteMaster.termsUrl && this.props.siteMaster.termsUrl.length > 5) ||
            (this.props.siteMaster.privacyUrl && this.props.siteMaster.privacyUrl.length > 5)
        ) {
            requiresTerms = true
        }

        if (requiresTerms && !this.state.approvedTerms) {
            hasErrors = true
            obj.termsError = ' '
        }

        this.setState(obj)
        return hasErrors
    }

    checkRegistration() {
        this.setState({ touched: true }, () => {
            var hasErrors = this.checkInputs()
            if (hasErrors) return

            //todo default time zone here
            var theTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

            var self = this
            this.setState({ masterErrorMsg: '', emailAddressError: '' })

            var query = queryString.parse(location.search)

            var theData = {
                accountName: self.state.companyName,
                emailAddress: self.state.emailAddress,
                password: self.state.password,
                firstName: self.state.firstName,
                lastName: self.state.lastName,
                url: window.location.host.split('/')[0],
                redirect: query.redirect,
                affiliateAccountUserId: self.state.affiliateId,
                newsletter: self.state.newsletterSignup,
                ps_xid: self.state.ps_xid,
                gclid: self.state.gclid
            }

            if (!theData.ps_xid && localStorage.getItem('ps_xid')) {
                theData.ps_xid = localStorage.getItem('ps_xid')
            }
            if (!theData.gclid && localStorage.getItem('gclid')) {
                theData.gclid = localStorage.getItem('gclid')
            }

            var baseUrl = DbConn.getConnString()

            this.setState({
                registering: true
            })

            axios
                .post(baseUrl + '/register', theData, { withCredentials: true })
                .then(function (response) {
                    var respData = response.data

                    if (!respData.accountMasterId) {
                        if (response.data.error.message === 'Email Address already exists') {
                            this.setState({
                                emailAddressError: i18n.t('login:register.emailExists')
                            })
                            return
                        } else if (response.data.error.message === 'Company name already exists') {
                            this.setState({
                                accountNameError: i18n.t('login:register.orgExists')
                            })
                            return
                        } else {
                            self.setState({
                                registering: false,
                                masterErrorMsg: response.data.error.message
                            })
                            return
                        }
                    }
                    if (respData.accountMasterId && self.props.siteMaster.siteId != 1) {
                        self.setState({
                            registering: false,
                            complete: true
                        })
                        return
                    }

                    if (respData.accountMasterId) {
                        // clean the ps_xid key from localstorage to prevent dupes
                        try {
                            localStorage.removeItem('ps_xid')
                            self.setState({
                                psx_id: null
                            })
                        } catch (e) {}
                        //clean the gclid key from localstorage to prevent dupes
                        try {
                            localStorage.removeItem('gclid')
                            self.setState({
                                gclid: null
                            })
                        } catch (e) {}
                        try {
                            if (self.props.siteMaster.siteId == 1) {
                                if (self.state.mpztid) {
                                    let host = 'transpond.io'
                                    let origin = 'https://transpond.io'
                                    TranspondTracking.pageChange(
                                        self.state.emailAddress,
                                        null,
                                        124555,
                                        self.state.mpztid,
                                        host,
                                        origin
                                    )
                                }
                                TranspondTracking.manualPageChange(
                                    null,
                                    null,
                                    self.state.emailAddress,
                                    null,
                                    null,
                                    'Registration',
                                    {
                                        accountName: self.state.companyName,
                                        accountMasterId: respData.accountMasterId
                                    }
                                )
                                postHogFunctions.capture('account_registration', {
                                    referrer: 'Organic'
                                })
                                GoogleAnalytics.tagManagerEvent(
                                    'Register',
                                    respData.accountMasterId,
                                    respData.accountUserId,
                                    self.state.emailAddress
                                )
                            }
                        } catch (err) {
                            console.log(err)
                        }

                        self.setState({
                            registering: false,
                            complete: true
                        })
                        return
                    }
                })
                .catch((error) => {
                    console.log(error)
                    if (error.response.data.error === 'Email Address already exists') {
                        this.setState({
                            registering: false,
                            emailAddressError: i18n.t('login:register.emailExists')
                        })
                        return
                    } else if (error.response.data.error === 'Company name already exists') {
                        this.setState({
                            registering: false,
                            accountNameError: i18n.t('login:register.orgExists')
                        })
                        return
                    } else {
                        self.setState({
                            registering: false,
                            masterErrorMsg: error.response.data.error
                        })
                        return
                    }
                })
        })
    }

    checkNewsletter(event) {
        this.setState({ newsletterSignup: event.currentTarget.checked })
    }
    render() {
        var mainMD = 8
        if (this.props.siteMaster.siteName != 'MPZMail' && this.props.siteMaster.siteName != 'Transpond') {
            mainMD = 12
        }

        let requiresTerms = false
        let termsTxt = [<span>I agree to the </span>]
        if (
            (this.props.siteMaster.termsUrl && this.props.siteMaster.termsUrl.length > 5) ||
            (this.props.siteMaster.privacyUrl && this.props.siteMaster.privacyUrl.length > 5)
        ) {
            requiresTerms = true
        }
        return (
            <Translation ns='translations'>
                {(t, { i18n }) => {
                    if (this.state.complete) {
                        return <Complete emailAddress={this.state.emailAddress} onClick={this.login} />
                    }
                    return (
                        <LandingPageTemplate
                            paperClasses='landing-register'
                            header={t('login:register.header')}
                            subheader={t('login:register.subheader')}
                            hideterms={true}
                        >
                            <TextInput
                                label={t('login:register.org')}
                                outerClassName='mar-b16'
                                type='text'
                                name='companyName'
                                value={this.state.companyName}
                                onChange={this.inputChange}
                                error={this.state.accountNameError}
                            />
                            <div className='row'>
                                <div className='col-xs-12 col-sm-6'>
                                    <TextInput
                                        label={t('login:register.first')}
                                        outerClassName='mar-b16'
                                        type='text'
                                        name='firstName'
                                        value={this.state.firstName}
                                        onChange={this.inputChange}
                                        error={this.state.firstNameError}
                                    />
                                </div>
                                <div className='col-xs-12 col-sm-6'>
                                    <TextInput
                                        label={t('login:register.last')}
                                        outerClassName='mar-b16'
                                        type='text'
                                        name='lastName'
                                        value={this.state.lastName}
                                        onChange={this.inputChange}
                                        error={this.state.lastNameError}
                                    />
                                </div>
                            </div>
                            <TextInput
                                label={t('login:login.email')}
                                outerClassName='mar-b16'
                                type='email'
                                name='emailAddress'
                                value={this.state.emailAddress}
                                onChange={this.inputChange}
                                error={this.state.emailAddressError}
                            />
                            <TextInput
                                type={this.state.type}
                                name='password'
                                label={t('login:login.password')}
                                labelSub={t('login:reset.strong')}
                                value={this.state.password}
                                onChange={this.inputChange}
                                error={this.state.masterErrorMsg}
                                outerClassName='mar-b24'
                                iconRight={
                                    <Icons
                                        icon='eye'
                                        className={
                                            this.state.type === 'password' ? 'icons-cross' : 'icons-cross active'
                                        }
                                        color='var(--neutral-900)'
                                        onClick={() => {
                                            this.setState({
                                                type: this.state.type === 'password' ? 'text' : 'password'
                                            })
                                        }}
                                    />
                                }
                            />
                            <div className='mar-b32'>
                                {requiresTerms && (
                                    <div className='checkboxWrapper mar-b4 mar-b12'>
                                        <CheckBox
                                            onClick={(event) => {
                                                let checked = event.target.checked
                                                this.setState({ approvedTerms: checked }, this.checkInputs)
                                            }}
                                            checked={this.state.approvedTerms}
                                            style={{ borderColor: this.state.termsError ? '1px solid red' : '' }}
                                            className='mar-r5'
                                        >
                                            <span
                                                className={
                                                    'landing-register__terms ' + (this.state.termsError ? 'error' : '')
                                                }
                                            >
                                                I accept the{' '}
                                                <a
                                                    href={this.props.siteMaster.termsUrl}
                                                    onMouseDown={(e) => {
                                                        e.preventDefault()
                                                        window.open(this.props.siteMaster.termsUrl, '_blank')
                                                    }}
                                                    target='_blank'
                                                >
                                                    Terms and Conditions
                                                </a>{' '}
                                                and{' '}
                                                <a
                                                    href={this.props.siteMaster.privacyUrl}
                                                    onMouseDown={(e) => {
                                                        e.preventDefault()
                                                        window.open(this.props.siteMaster.termsUrl, '_blank')
                                                    }}
                                                    target='_blank'
                                                >
                                                    Privacy Policy
                                                </a>
                                            </span>
                                        </CheckBox>
                                    </div>
                                )}
                                {this.props.siteMaster.siteId == 1 && (
                                    <div className='checkboxWrapper'>
                                        <CheckBox
                                            onClick={this.checkNewsletter}
                                            checked={this.state.newsletterSignup}
                                            className='mar-b24 mar-r5'
                                        >
                                            <span className='landing-register__terms'>
                                                {t('login:register.newsletter', {
                                                    siteName: this.props.siteMaster.siteName
                                                })}
                                            </span>
                                        </CheckBox>
                                    </div>
                                )}
                            </div>
                            <Button
                                className='button-primary button-fullwidth'
                                iconRight={<Icons icon='arrowRight' />}
                                onClick={this.checkRegistration}
                                disabled={this.state.registering}
                            >
                                {t('login:register.button')}
                            </Button>
                            <div style={{ textAlign: 'center', color: 'var(--neutral-800)' }} className='mar-t16'>
                                {t('login:register.haveAccount')}
                                <Link style={{ marginLeft: 3 }} to='/'>
                                    {t('login:register.login')}
                                </Link>
                            </div>
                        </LandingPageTemplate>
                    )
                    return (
                        <div className='login-holder'>
                            {(this.props.siteMaster.siteName === 'MPZMail' ||
                                this.props.siteMaster.siteName === 'Transpond') && (
                                <LeftPanel history={this.props.history} registerPage={true} />
                            )}
                            {this.state.complete && (
                                <RegisterComplete history={this.props.history} login={this.login} />
                            )}

                            {!this.state.complete && (
                                <div className='login-right-panel'>
                                    <div className='login-right-panel-login'>
                                        <Paper className='login-right-panel-login_loginBox'>
                                            <h3
                                                className='mar-b5'
                                                dangerouslySetInnerHTML={{
                                                    __html: t('login:register.create', {
                                                        site: this.props.siteMaster.siteName
                                                    })
                                                }}
                                            />
                                            <div className='paper_subheading mar-b40'>
                                                {t('login:register.subHeader')}
                                            </div>

                                            <TextInput
                                                maxLength='255'
                                                className='mar-b24'
                                                type='text'
                                                name='companyName'
                                                label={t('login:register.company')}
                                                onChange={this.inputChange}
                                                onKeyPress={this.inputChange}
                                                focus={true}
                                                error={this.state.accountNameError}
                                            />

                                            <div className='row'>
                                                <div className='col-xs-12 col-sm-6'>
                                                    <TextInput
                                                        maxLength='255'
                                                        className='mar-b24'
                                                        type='text'
                                                        name='firstName'
                                                        label={t('login:register.first')}
                                                        onKeyPress={this.inputChange}
                                                        onChange={this.inputChange}
                                                        error={this.state.firstNameError}
                                                    />
                                                </div>
                                                <div className='col-xs-12 col-sm-6'>
                                                    <TextInput
                                                        maxLength='255'
                                                        className='mar-b24'
                                                        type='text'
                                                        name='lastName'
                                                        label={t('login:register.last')}
                                                        onKeyPress={this.inputChange}
                                                        onChange={this.inputChange}
                                                        error={this.state.lastNameError}
                                                    />
                                                </div>
                                            </div>

                                            <TextInput
                                                maxLength='255'
                                                className='mar-b24'
                                                type='email'
                                                name='emailAddress'
                                                label={t('login:login.emailPlaceholder')}
                                                onChange={this.inputChange}
                                                onKeyPress={this.inputChange}
                                                error={this.state.emailAddressError}
                                            />

                                            <TextInput
                                                maxLength='255'
                                                className='mar-b24'
                                                type='password'
                                                name='password'
                                                label={t('login:login.passwordPlaceholder')}
                                                onChange={this.inputChange}
                                                onKeyPress={this.inputChange}
                                                error={this.state.masterErrorMsg}
                                            />

                                            {(requiresTerms || this.props.siteMaster.siteId == 1) && <hr />}

                                            {requiresTerms && (
                                                <div className='checkboxWrapper mar-b25'>
                                                    <CheckBox
                                                        disabled={false}
                                                        onClick={(event) => {
                                                            let checked = event.target.checked
                                                            this.setState({ approvedTerms: checked }, this.checkInputs)
                                                        }}
                                                        checked={this.state.approvedTerms}
                                                        style={{
                                                            borderColor: this.state.termsError ? '1px solid red' : ''
                                                        }}
                                                        className='mar-r5'
                                                    />
                                                    {termsTxt}
                                                    {this.state.termsError && (
                                                        <FormError key={'err'}>
                                                            {this.state.termsError}
                                                        </FormError>
                                                    )}
                                                </div>
                                            )}

                                            {this.props.siteMaster.siteId == 1 && (
                                                <div className='checkboxWrapper mar-b25'>
                                                    <CheckBox
                                                        disabled={false}
                                                        onClick={this.checkNewsletter}
                                                        checked={this.state.newsletterSignup}
                                                        className='mar-b24 mar-r5'
                                                    />
                                                    Receive news and updates about Transpond
                                                </div>
                                            )}
                                            {(requiresTerms || this.props.siteMaster.siteId == 1) && <hr />}

                                            <Button
                                                className='button-primary mar-r20'
                                                text={t('login:register.button')}
                                                disabled={this.state.registering}
                                                onClick={this.checkRegistration}
                                            />
                                            <a
                                                onClick={() => {
                                                    this.redirectToPage('')
                                                }}
                                            >
                                                {t('login:register.haveAccount')}
                                            </a>
                                        </Paper>
                                    </div>
                                </div>
                            )}
                        </div>
                    )
                }}
            </Translation>
        )
    }
}

function Complete({ emailAddress, onClick = () => {} }) {
    return (
        <LandingPageTemplate
            paperClasses='landing-register'
            header={i18n.t('login:register.complete.header')}
            subheader={<div style={{ marginTop: 12 }}>{i18n.t('login:register.complete.subheader')}</div>}
            subsubheader={
                <div
                    dangerouslySetInnerHTML={{
                        __html: i18n.t('login:register.complete.subsubheader', { emailAddress: emailAddress })
                    }}
                ></div>
            }
        >
            <Button
                className='button-primary button-fullwidth'
                iconRight={<Icons icon='arrowRight' />}
                onClick={onClick}
            >
                {i18n.t('login:register.complete.getStarted')}
            </Button>
        </LandingPageTemplate>
    )
}
